import React from 'react';
import { trackCheckoutStart } from '../lib/metaPixel';

/** Every CTA on the page points at this single checkout. */
export const CHECKOUT_URL = 'https://babysleepbible.impultienda.ar/checkout';
export const CURRENCY_NOTE = 'Payments are processed in your local currency';
interface CtaButtonProps {
  label: string;
  className?: string;
  size?: 'md' | 'lg';
}
export function CtaButton({
  label,
  className = '',
  size = 'lg'
}: CtaButtonProps) {
  const sizing = size === 'lg' ? 'px-8 py-4 text-[13px] sm:text-sm' : 'px-5 py-3 text-[13px]';
  return <a href={CHECKOUT_URL} onClick={trackCheckoutStart} className={`group inline-flex items-center justify-center gap-2.5 rounded-[12px] bg-brand-terracotta font-body font-semibold uppercase tracking-[0.08em] text-brand-terracotta-text transition-colors duration-200 ease-out hover:bg-brand-terracotta-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-terracotta focus-visible:ring-offset-2 focus-visible:ring-offset-brand-ivory ${sizing} ${className}`} data-id="element-1" data-mp="ljeboozazbmw">
      <span data-id="element-2" data-mp="35z8x6sufg1lg">{label}</span>
      <span aria-hidden="true" className="text-base font-normal transition-transform duration-200 ease-out group-hover:translate-x-1" data-id="element-3" data-mp="39yhozs5wpped">
        →
      </span>
    </a>;
}
interface CtaBlockProps {
  label: string;
  /** Small line above the price, e.g. what is included. */
  meta?: string;
  className?: string;
}

/**
 * Centered purchase block. The price lives OUTSIDE the button and keeps its own
 * visual identity; the terracotta button is reserved for the action itself.
 */
export function CtaBlock({
  label,
  meta,
  className = ''
}: CtaBlockProps) {
  return <div className={`flex flex-col items-center text-center ${className}`} data-id="element-4" data-mp="6i15gqw5v1dm">
      {meta && <p className="font-body text-[11px] uppercase tracking-[0.18em] text-brand-charcoal/50" data-id="element-5" data-mp="6jvizk53rr7o">
          {meta}
        </p>}
      <p className="mt-3 font-body text-[2rem] font-bold leading-none tracking-[-0.01em] text-brand-charcoal" data-id="element-6" data-mp="gffalucmw3qm">
        23 USD
      </p>
      <p className="mt-2.5 font-body text-[11px] uppercase tracking-[0.14em] text-brand-charcoal/50" data-id="element-7" data-mp="3mxz1g39q2jyi">
        {CURRENCY_NOTE}
      </p>
      <CtaButton label={label} className="mt-4 w-full sm:w-auto" data-id="element-8" data-mp="hw4g9bmchn3" />
    </div>;
}